import React from 'react';
import { useTranslation } from 'react-i18next';
import './CauseCard.scss';

type CauseCardProps = {
  name: string;
  logo: string;
  parentName?: string;
  className?: string;
};

const CauseCard = ({
  name,
  logo,
  parentName,
  className = '',
}: CauseCardProps) => {
  const { t } = useTranslation();
  return (
    <div data-qa="causeCard" className={`jg-tc-causecard ${className}`}>
      <div className="jg-tc-causecard__image">
        <img src={logo} alt="" />
      </div>
      <div data-qa="cause-card-name">
        <div className="jg-tc-causecard__title">{name}</div>
        {parentName && (
          <div className="jg-text--small-regular">
            <span className="jg-text--light"> {t('global.for')}</span>{' '}
            {parentName}
          </div>
        )}
      </div>
    </div>
  );
};

export default CauseCard;
